(() => {
  const R = window.Rayor || {};
  const money = (cents) => {
    const fmt = R.money || '{{amount}}';
    const v = cents / 100, two = v.toFixed(2), noDec = Math.round(v).toString();
    const sep = (n, s, d) => { const [a, b] = n.split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, s) + (b ? d + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: sep(two, ',', '.'), amount_no_decimals: sep(noDec, ',', '.'),
      amount_with_comma_separator: sep(two, '.', ','), amount_no_decimals_with_comma_separator: sep(noDec, '.', ','),
      amount_with_space_separator: sep(two, ' ', ','), amount_with_apostrophe_separator: sep(two, "'", '.')
    }[k] || two));
  };
  const lines = document.getElementById('cart-lines');
  const update = (cart) => {
    const n = cart.item_count || 0;
    const nudge = document.getElementById('cart-nudge');
    if (nudge) {
      let m = '';
      if (n === 1) m = '<b>Add 1 more item</b> and save 10% on your whole order.';
      else if (n === 2) m = 'You’re saving 10%. <b>Add 1 more item</b> to save 15%.';
      else if (n >= 3) m = '<b>Bundle unlocked</b> — you’re saving 15% or more.';
      nudge.innerHTML = m;
      nudge.style.setProperty('--p', (Math.min(n, 3) / 3 * 100) + '%');
    }
    const saved = (cart.original_total_price || 0) - (cart.total_price || 0);
    const row = document.getElementById('cart-save-row');
    if (row) { row.hidden = !(saved > 0); const s = document.getElementById('cart-save'); if (s) s.textContent = '−' + money(saved); }
    if (lines && cart.items) {
      const ps = lines.querySelectorAll('.line .p');
      cart.items.forEach((it, i) => { const p = ps[i]; if (p && it.original_line_price > it.final_line_price && !p.querySelector('s')) p.insertAdjacentHTML('beforeend', '<s>' + money(it.original_line_price) + '</s>'); });
    }
  };
  let t;
  const refresh = () => { clearTimeout(t); t = setTimeout(() => fetch('/cart.js').then(r => r.json()).then(update).catch(() => {}), 80); };
  if (lines) new MutationObserver(refresh).observe(lines, { childList: true });
  refresh();
})();
